// as-cetra-ui/src/components/authenticated/handout/customise-mode/ConfirmRemoveDialog.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const ConfirmRemoveDialog = ({ open, onClose, onConfirm, title, message }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onConfirm} color="primary" autoFocus>
                    Yes
                </Button>
                <Button onClick={onClose}>No</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmRemoveDialog;
